import { render } from "./RiskApplicationRefer.vue?vue&type=template&id=5c4363d2"
import script from "./RiskApplicationRefer.vue?vue&type=script&lang=js"
export * from "./RiskApplicationRefer.vue?vue&type=script&lang=js"

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__